import strFunc from "@/lib/lyg/string";
import PrescribeInputText from "./input_text";
import { useState } from 'react';

function DailyPrescribeAera(props: any) {
  let myProps = {
    Style: {},
    select_date: "",
    pre_date_str: "",
    subject_name: "",
    daily_prescribe_info: {},
    info: {},
    set_info: (inData: any) => { },
    save_daily_prescribe_by_stu_arr: (inData: any) => { },
    delete_daily_prescribe_by_stu_arr: (inData: any) => { },
    ...props
  };
  let info = myProps.info;
  let Style = myProps.Style;
  let daily_prescribe_info = myProps.daily_prescribe_info;

  const [is_able_write, set_is_able_write] = useState(false);

  let is_able_del = false;
  if (!strFunc.is_empty(daily_prescribe_info["a_seq"])
    && daily_prescribe_info["a_write_date"] == myProps.select_date) {
    is_able_del = true;
  }

  const on_change_daily_prescribe_info = (inData: any) => {
    let name = inData.target.name;
    let value = inData.target.value;
    let change_daily_prescribe_info = { ...daily_prescribe_info };
    change_daily_prescribe_info[name] = value;

    if (info.daily_prescribe_arr == undefined) {
      info.daily_prescribe_arr = [];
    }
    let dp_idx = -1;
    for (let i = 0; i < info.daily_prescribe_arr.length; i++) {
      let tmp_row_data = info.daily_prescribe_arr[i];
      if (tmp_row_data["a_stu_seq"] == daily_prescribe_info["a_stu_seq"]
        && tmp_row_data["a_subject"] == daily_prescribe_info["a_subject"]
        && tmp_row_data["a_write_date"] == daily_prescribe_info["a_write_date"]
      ) {
        dp_idx = i;
      }
    }
    
    if (dp_idx == -1) {
      info.daily_prescribe_arr.push(change_daily_prescribe_info);
    } else {
      info.daily_prescribe_arr[dp_idx] = change_daily_prescribe_info;
    }

    myProps.set_info(info);
  };

  const save_daily_prescribe_by_stu_arr_row = (inData: any) => {
    let value = inData.target.value;

    if (strFunc.is_empty(daily_prescribe_info["a_seq"])
      && strFunc.is_empty(value)) {
      return false;
    }
    if (strFunc.is_empty(daily_prescribe_info["a_seq"])) {
      daily_prescribe_info["a_ymd"] = strFunc.getNumber2(myProps["select_date"]);
      daily_prescribe_info["a_seq"] = "";
      daily_prescribe_info["a_write_date"] = myProps["select_date"];
    }

    if (!strFunc.is_empty(daily_prescribe_info["a_subject"])
      && !strFunc.is_empty(daily_prescribe_info["a_writer_seq"])) {
      myProps.save_daily_prescribe_by_stu_arr({
        daily_prescribe_arr: [daily_prescribe_info],
        is_show_loading: true,
      });
    }

    set_is_able_write(false);
  };

  let td_style:any = {
    verticalAlign: "top",
  };

  return (
    <div >
      <table className={Style.daily_prescribe_table}>
        <colgroup>
          <col width={"70px"}></col>
          <col width={"25%"}></col>
          <col width={"70px"}></col>
          <col width={"15%"}></col>
          <col width={"70px"}></col>
          <col width={"5%"}></col>
          <col width={"70px"}></col>
          <col width={"15%"}></col>
          <col width={"70px"}></col>
          <col width={"5%"}></col>
          <col width={"15%"}></col>
          <col width={"1%"}></col>
        </colgroup>
        <tbody>
          <tr>
            <td>
              <span style={{ width: "70px", display: "inline-block" }}>issue</span>
            </td>
            <td style={td_style}>
              <PrescribeInputText
                name="a_issue"
                daily_prescribe_info={daily_prescribe_info}
                on_change_daily_prescribe_info={on_change_daily_prescribe_info}
                // onBlur={save_daily_prescribe_by_stu_arr_row}
                is_able_write={is_able_write}
              ></PrescribeInputText>
            </td>
            <td>
              <span style={{ width: "70px", display: "inline-block" }}>숙제plan</span>
            </td>
            <td style={td_style}>
              <PrescribeInputText
                name="a_homework_plan"
                daily_prescribe_info={daily_prescribe_info}
                on_change_daily_prescribe_info={on_change_daily_prescribe_info}
                // onBlur={save_daily_prescribe_by_stu_arr_row}
                is_able_write={is_able_write}
              ></PrescribeInputText>
            </td>
            <td>
              <span style={{ width: "70px", display: "inline-block" }}>숙제량</span>
            </td>
            <td style={td_style}>
              <PrescribeInputText
                name="a_homework_amount"
                daily_prescribe_info={daily_prescribe_info}
                on_change_daily_prescribe_info={on_change_daily_prescribe_info}
                // onBlur={save_daily_prescribe_by_stu_arr_row}
                is_able_write={is_able_write}
              ></PrescribeInputText>
            </td>
            <td>
              <span style={{ width: "70px", display: "inline-block" }}>진도plan</span>
            </td>
            <td style={td_style}>
              <PrescribeInputText
                name="a_progress_plan"
                daily_prescribe_info={daily_prescribe_info}
                on_change_daily_prescribe_info={on_change_daily_prescribe_info}
                // onBlur={save_daily_prescribe_by_stu_arr_row}
                is_able_write={is_able_write}
              ></PrescribeInputText>
            </td>
            <td>
              <span style={{ width: "70px", display: "inline-block" }}>진도량</span>
            </td>
            <td style={td_style}>
              <PrescribeInputText
                name="a_progress_amount"
                daily_prescribe_info={daily_prescribe_info}
                on_change_daily_prescribe_info={on_change_daily_prescribe_info}
                // onBlur={save_daily_prescribe_by_stu_arr_row}
                is_able_write={is_able_write}
              ></PrescribeInputText>
            </td>
            <td style={td_style}>
              <PrescribeInputText
                name="a_memo"
                daily_prescribe_info={daily_prescribe_info}
                on_change_daily_prescribe_info={on_change_daily_prescribe_info}
                // onBlur={save_daily_prescribe_by_stu_arr_row}
                is_able_write={is_able_write}
                placeholder="메모"
              ></PrescribeInputText>
            </td>
            <td>
              <div className="my_flex_center">
                <button className="btn-s btn-gray"
                  style={{ background: is_able_write ? "#a2b854" : "" }}
                  onClick={() => {
                    if (is_able_write) {
                      save_daily_prescribe_by_stu_arr_row({ target: { value: "1" } });
                    } else {
                      set_is_able_write(!is_able_write);
                    }
                  }}>
                  {is_able_write ? "저장" : "수정"}
                </button>
                {is_able_del &&
                  <button className="btn-s btn-red"
                    onClick={() => {
                      myProps.delete_daily_prescribe_by_stu_arr({
                        daily_prescribe_arr: [daily_prescribe_info],
                      });
                    }}
                  >X</button>
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default DailyPrescribeAera;